import { RecursiveNull } from '@editor/interfaces'

export const notNull = <T extends any>(props: T): RecursiveNull<T> =>
  props as RecursiveNull<T>
